export const COMMUNITY_WEB_ACTION = 'community_action';

export const EventAction = {
  COMMUNITY_SIGN_IN: 'community_sign_in',
  COMMUNITY_LOGOUT: 'community_logout',
  COMMUNITY_CLICKED_FROM_HAMBURGER: 'community_clicked_from_hamburger',
  COMMUNITY_CLICKED_FROM_FOOTER: 'community_clicked_from_footer',
  COMMUNITY_CLICKED_FROM_DROPDOWN: 'community_clicked_from_dropdown',
} as const;

export const ViewMode = {
  COMMUNITY_SSO_NAVIGATE: 'community_sso_navigate',
  HAMBURGER_MENU: 'hamburger_menu',
  PROFILE: 'profile',
  DROPDOWN_PROFILE: 'dropdown_profile',
} as const;

export const PageView = {
  COMMUNITY_REDIRECT: 'community_redirect',
} as const;
